document.addEventListener('DOMContentLoaded', function () {
  // Mobile nav toggle
  var hamb = document.querySelector('[data-hamb]');
  var links = document.querySelector('[data-nav-links]');
  if (hamb && links) {
    hamb.addEventListener('click', function () {
      links.classList.toggle('is-open');
    });
  }

  // FAQ accordion
  document.querySelectorAll('.faqItem').forEach(function (item) {
    var btn = item.querySelector('.faqQ');
    var answer = item.querySelector('.faqA');
    if (!btn || !answer) return;
    btn.addEventListener('click', function () {
      var isOpen = item.classList.contains('open');
      item.closest('.faq').querySelectorAll('.faqItem.open').forEach(function (openItem) {
        if (openItem !== item) {
          openItem.classList.remove('open');
          openItem.querySelector('.faqA').style.maxHeight = null;
        }
      });
      if (isOpen) {
        item.classList.remove('open');
        answer.style.maxHeight = null;
      } else {
        item.classList.add('open');
        answer.style.maxHeight = answer.scrollHeight + 'px';
      }
    });
  });
});
